import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const MainContainer = styled.div``;

export const Container = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #efe9fb;
  background: #f9f6ff;
`;

export const TextContainer = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  ${(props) => props.styles}

  span {
    color: #7c47e1;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-left: 4px;
  }
`;

export const CueTextContainer = styled.p`
  color: #5b5675;
  font-size: 12px;
  font-weight: 400;
  margin-top: 8px;
  line-height: 18px;
`;
